<ng-container *ngIf="date">
  <code>{{ date.format(format) }}</code>
</ng-container>
